"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { d: "M25.7898 14.2498L31.6269 19.2183C32.1244 19.6292 32.1244 20.3708 31.6269 20.7817L25.7898 25.7502C25.0967 26.3226 24.0261 25.8481 24.0261 24.9684V22.0591H9.06841C8.47834 22.0591 8 21.5982 8 21.0296V18.9704C8 18.4018 8.47834 17.9409 9.06841 17.9409H24.0261V15.0316C24.0261 14.1519 25.0967 13.6774 25.7898 14.2498Z", fill: colour }));
};
//# sourceMappingURL=ArrowOneWay.js.map